/*
 * @Description: 系统设置-角色管理-API
 */

import { formatTableGetParams, formatTableResponse } from '@/utils/utils';
import { httpRequest } from '@/utils/umiRequest';

// 获取角色列表
export async function fetchRole(data?: any, include?: any, options?: Record<string, any>) {
  const _params = formatTableGetParams(data);
  const response = await httpRequest.get(
    '/role-permissions',
    {
      ..._params,
      ...include,
    },
    options,
  );

  return formatTableResponse(response);
}

// 删除角色
export async function deleteRoleAPI(data: any, options?: Record<string, any>) {
  return await httpRequest.delete('/role-permissions', data, options);
}

// 获取所有权限
export async function permissionsAPI(options?: Record<string, any>) {
  return await httpRequest.get<any>('/permissions', {}, options);
}

// 新增角色
export async function createRolePermissionsAPI(
  data: { name: string; permissions: any[]; department_ids: any[], is_view_all: boolean },
  options?: Record<string, any>,
) {
  return await httpRequest.post('/role-permissions', data, options);
}

// 删除角色
export async function deleteRolePermissionsAPI(id: string, options?: Record<string, any>) {
  return await httpRequest.delete(`/role-permissions/${id}`, {}, options);
}

// 编辑角色权限
export async function editRolePermissionsAPI(
  id: string,
  data: { name: string; permissions: any[]; department_ids: any[], is_view_all: boolean, view_tag_ids: string[] },
  options?: Record<string, any>,
) {
  return await httpRequest.put(`/role-permissions/${id}`, data, options);
}
